import { render, staticRenderFns } from "./RequiredDurationComponent.vue?vue&type=template&id=36bad0f2&scoped=true"
import script from "./RequiredDurationComponent.vue?vue&type=script&lang=js"
export * from "./RequiredDurationComponent.vue?vue&type=script&lang=js"
import style0 from "./RequiredDurationComponent.vue?vue&type=style&index=0&id=36bad0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bad0f2",
  null
  
)

export default component.exports